export enum SessionTypes {
    unknown = 'unknown',
    partial = 'partial',
    full = 'full',
}

export type DeliveryData = {
    address1: string;
    address2: string;
    city: string;
    postalCode: string;
    shippingCountry: string;
    shippingCountryCode: string;
    shippingCountryName: string;
};

export interface UserData {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    registeredAt: string;
    loginHash: string;
    hashedId: string;
    hashedEmail: string;
    sessionType: SessionTypes;
    deliveryData: DeliveryData;
    isBuyer: boolean;
    isB2BNew: boolean;
    segmentHash: string;
    subscribedSimpleSkus: string[];
    loginType: string;
    regFormType: string;
    userRegistration: {
        mdprefid: string;
        utmSource: string;
        utmMedium: string;
        utmCampaign: string;
        utmContent: string;
        utmTerm: string;
    };
    userTitle: string;
    isFirstRequestAfterLogin: boolean;
}

export interface ValidationErrors {
    email?: string | string[];
    password?: string | string[];
}

export type LoginResponseError = [] | {};

export interface AppShellLoginState {
    isFetching: boolean;
    didInvalidate: boolean;
    didFinishOnce: boolean;
    isLoggedIn: boolean;
    shouldShowDataPolicyOverlay: boolean;
    isRegistered: boolean;
    isRegisteredWithNewsletter: boolean;
    isReturningUser: boolean;
    data: UserData | undefined;
    redirectUrl?: string;
    launchDarklyUserKey?: string;
    journeyId?: string;
    error: LoginResponseError | ValidationErrors | Error;
    isFirstRequestAfterLogin?: boolean;
    isFirstRequestAfterSignup?: boolean;
    isAutoLogin?: boolean;
}
